/*eslint-disable*/
import { useContext, useEffect, useState } from 'react';
import ListHeader from '../../SectionHeader';
import TablePagination from '../../TablePaginationComponent';
// Import DeleteIcon from '@mui/icons-material/Delete';
import GlobalContext from '../../../contexts';
import { ReactComponent as SortIcon } from '../../../assets/images/sort.svg';
import Filter from '../../Filter';
import BasicDialog from 'components/Dialog';
import useSort from '../../../hooks/useSort';
import SnackBar from 'components/SnackBar';
import EditMeeting from './editMeeting';
import { HealthCoachSummey } from 'components/Survey/HealthCoachSummey';

import BasicDrawer from 'components/Drawer';
import translating from '../translate.json';
import DeleteIcon from '@mui/icons-material/Delete';
import usePostData from 'hooks/usePostData';
import moment from 'moment';
import PropTypes from 'prop-types';
import enumTherapistsType from 'enums/enum-therapists-type';
import { DoctorSummery } from 'components/Survey/DoctorSummery';
import eProductType from 'enums/enum-product-type';
import { DoctorSummeryPredibetes } from 'components/Prediabetes/DoctorSummery';

function Meetings({ data }) {
  const { categoriesList, regionEnum, currentUser } = useContext(GlobalContext),
    [filteredmeetings, setFilteredmeetings] = useState([]),
    { showFilters, toggle } = useSort(),
    { res: meetingsData } = !data
      ? usePostData(
          `client-therapist-scheduler/meetingsbyTherapist/${currentUser?.user_uuid}`,
          {}
        )
      : data,
    [showSnackbar, setShowSnakbar] = useState(false),
    [openDrawer, setOpenDrawer] = useState(false),
    { setCurrentMeetingsDetails, setCurrentMeeting } =
      useContext(GlobalContext),
    [currentMeetingId, setCurrentMeetingId] = useState(null),
    [currentMeetingsData, setCurrentMeetingsData] = useState(),
    { res, postData, error } = usePostData(),
    [deletedId, setDeletedId] = useState(),
    [lastUpdated, setLastUpdated] = useState(),
    [therapists, setTherapists] = useState(null),
    [clients, setClients] = useState(null);

  useEffect(() => {
    if (currentMeetingsData?.length) {
      const tmpData = [...currentMeetingsData];
      let cp = '',
        count = 0;

      tmpData.forEach((td, index) => {
        if (index === 0) cp = td.clientProductId;
        if (td.clientProductId !== cp) {
          cp = td.clientProductId;
          count = 0;
        }
        if (td.isActive) {
          count = count + 1;
          td.scheduledAppoitments = count;
        } else td.scheduledAppoitments = null;
      });
      setFilteredmeetings(tmpData);
    }
  }, [currentMeetingsData, data]);

  useEffect(() => {
    if (data || meetingsData?.meetingsList) {
      if (data) setCurrentMeetingsData(data);
      else {
        setCurrentMeetingsData(meetingsData.meetingsList);
        setLastUpdated(meetingsData.lastUpdatedMeetings);

        setTherapists(
          meetingsData.therapists.map((t) => ({ id: t.id, name: t.name }))
        );
        setClients(
          meetingsData.clients.map((c) => ({ id: c.id, name: c.name }))
        );
      }
    }
  }, [meetingsData]);

  useEffect(() => {
    if (res) {
      console.log('res from delete appointment: ', res);
      if (res.status === 1) {
        const tmpMeetings = [...filteredmeetings],
          index = tmpMeetings.findIndex((m) => m.id === deletedId);
        tmpMeetings[index].isActive = 0;
        setShowSnakbar('הפגישה בוטלה');
        setFilteredmeetings(tmpMeetings);
        setDeletedId(null);
      } else if (res.status === '0')
        alert(
          res.message === 'not live appointment'
            ? 'אין אפשרות לבטל פגישה זאת היות שכבר בוטלה בעבר'
            : res.message
        );
    }
  }, [res, error]);

  const actionsCustomersList = [
      {
        icon: SortIcon,
        bottom: true,
        txt: 'עריכה',
        handleClickAction: () => {
          showFilters && setFilteredmeetings(meetingsData);
          toggle(!showFilters);
        }
      }
    ],
    handleDeleteItem = (id, event) => {
      event.preventDefault();
      setDeletedId(id);
    },
    removeItem = () => {
      postData(`client-therapist-scheduler/${deletedId}`, {}, 'delete');
    },
    tableHeaders = [
      translating.therapistName,
      translating.terapistDomain,
      translating.clientName,
      translating.clientMobile,
      translating.clientEmail,
      translating.productName,
      translating.meetingDate,
      translating.meetingHour,
      translating.scheduledAppoitments,
      translating.zoom,
      translating.status,
      ''
    ],
    columns = [
      { value: 'therapistFullName', sort: true },
      { value: 'categoryName', sort: true },
      { value: 'clientFullName', sort: true },
      { value: 'clientMobile', bold: true },
      { value: 'clientEmail', sort: true },
      { value: 'product_name', sort: true },
      { value: 'startDate', format: 'date', sort: true },
      { value: 'startDate', format: 'hour', sort: true },
      { value: 'scheduledAppoitments', sort: true },
      { value: 'apointmentUrlStart', format: 'link' },
      { value: 'status', sort: true },
      { value: '', icon: DeleteIcon, handleAction: handleDeleteItem }
    ],
    sortFields = [
      {
        type: 'search',
        label: translating.search,
        placeholder: translating.type3Dots,
        name: 'search',
        fields: [
          'therapistFullName',
          'clientFullName',
          'clientEmail',
          'clientMobile'
        ]
      },
      {
        type: 'date',
        subType: 'fromDate',
        label: translating.fromDate,
        name: 'fromDate',
        field: 'startDate'
      },
      {
        type: 'date',
        subType: 'toDate',
        label: translating.toDate,
        name: 'toDate',
        field: 'endDate'
      },

      {
        type: 'select',
        label: translating.terapistDomain,
        name: 'categoryId',
        options: categoriesList,
        isId: true
      },
      {
        type: 'select',
        label: translating.terapistRegion,
        name: 'region',
        options: regionEnum
      },
      {
        type: 'autocomplete',
        label: translating.therapistName,
        name: 'therapistId',
        options: therapists,
        searchBy: 'name'
      },
      {
        type: 'autocomplete',
        label: translating.clientName,
        name: 'clientId',
        options: clients,
        searchBy: 'name'
      }
    ],
    onFilter = (filteredData) => {
      setFilteredmeetings(filteredData);
    },
    onResetFilters = () => {
      setFilteredmeetings(currentMeetingsData);
    };

  return (
    <div className="meetings-list">
      {!data && (
        <ListHeader
          actions={actionsCustomersList}
          title={translating.terapistMeetingsTitle}
        />
      )}

      {filteredmeetings?.length ? (
        <div className="last-updated-area">
          <div>עודכן לאחרונה ב-</div>
          {<div>{moment(lastUpdated).format('DD.MM.YYYY')}</div>}{' '}
          <div>{moment(lastUpdated).format('HH:mm')}</div>
        </div>
      ) : (
        ''
      )}
      {!data &&
      showFilters &&
      categoriesList?.length &&
      therapists?.length &&
      clients?.length ? (
        <Filter
          data={filteredmeetings}
          fields={sortFields}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        />
      ) : null}
      <div className="meetings-list-wrapper-table">
        <div className="count-clients">{`נמצאו ${filteredmeetings?.length} פגישות `}</div>

        {currentMeetingsData ? (
          <TablePagination
            columns={columns}
            useUId
            handleRowClick={(client_uuid) => {
              const currentMeeting = currentMeetingsData.find(
                (m) => m.client_uuid === client_uuid
              );
              setCurrentMeeting(currentMeeting);
              if (currentMeeting.status !== 'בוטל') {
                setCurrentMeetingsDetails(currentMeeting);
                setCurrentMeetingId(currentMeeting.id);
                switch (currentMeeting.categoryName) {
                  case enumTherapistsType.nutritionist:
                    setOpenDrawer('editMeeting');
                    break;
                  case enumTherapistsType.examer:
                    setOpenDrawer('surveyMeasures');
                    break;
                  case enumTherapistsType.coach:
                    setOpenDrawer('healthCoachSummery');
                    break;
                  case enumTherapistsType.doctor:
                    const productType =
                      currentMeeting.productParentId === 0
                        ? currentMeeting.productId
                        : currentMeeting.productParentId;
                    if (productType === eProductType.survey)
                      setOpenDrawer('doctorSummery');
                    else setOpenDrawer('doctorPredibetesSummery');
                    break;
                  default:
                    break;
                }
              }
            }}
            headers={tableHeaders}
            pagination
            rows={filteredmeetings}
          />
        ) : null}
      </div>
      {showSnackbar ? (
        <SnackBar
          handleClose={() => setShowSnakbar(false)}
          msg={showSnackbar}
        />
      ) : null}
      {openDrawer ? (
        <BasicDrawer
          onClose={() => {
            setOpenDrawer(false);
          }}
          open={openDrawer}
        >
          <div className="wrapper-drawer">
            {(() => {
              switch (openDrawer) {
                case 'editMeeting':
                  return (
                    <EditMeeting
                      meetingId={currentMeetingId}
                      setOpenDrawer={setOpenDrawer}
                    />
                  );
                case 'healthCoachSummery':
                  return (
                    <HealthCoachSummey
                      handleClose={setOpenDrawer}
                    ></HealthCoachSummey>
                  );
                case 'doctorSummery':
                  return <DoctorSummery />;
                case 'doctorPredibetesSummery':
                  return <DoctorSummeryPredibetes />;
                default:
                  return;
              }
            })()}
          </div>
        </BasicDrawer>
      ) : null}
      {deletedId ? (
        <BasicDialog
          description={translating.removeDescription}
          handleClose={() => setDeletedId(null)}
          handleSubmit={removeItem}
          title={translating.removeTitle}
        />
      ) : null}
    </div>
  );
}

export default Meetings;

Meetings.propTypes = {
  data: PropTypes.array
};
